import { render, staticRenderFns } from "./payment-result.vue?vue&type=template&id=275caee2&"
import script from "./payment-result.vue?vue&type=script&lang=js&"
export * from "./payment-result.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports